import { FieldName, FormValidationResult, FormValues } from 'types/form';

export type CreateContactMutation = {
  email: string;
};

export const NewsletterFormFields = {
  email: 'email' as FieldName<string>,
};

export type NewsletterFormValues = FormValues<typeof NewsletterFormFields>;
export type NewsletterFormValidationResult = FormValidationResult<typeof NewsletterFormFields>;
export type NewsletterFormValidated = Required<NewsletterFormValues>;

export enum Languages {
  PT_BR = 'pt-BR',
  EN_US = 'en-US',
}

export const LanguagesFields = {
  language: 'language' as FieldName<Languages>,
};
